// App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import LandingPage from './LandingPage.jsx';
import PrivacyPolicy from './PrivacyPolicy.jsx';
import About from './About.jsx';
import SupportPage from './SupportPage.jsx';
// Если позже добавишь Terms:
// import TermsOfUse from './TermsOfUse.jsx';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Главная */}
        <Route path="/" element={<LandingPage />} />

        {/* Политика конфиденциальности */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* Поддержка */}
        <Route path="/support" element={<SupportPage />} />

        {/* О компании SEOTIV */}
        <Route path="/about" element={<About />} />

        {/* Условия использования (будет позже)
        <Route path="/terms" element={<TermsOfUse />} />
        */}

        {/* Fallback: все неизвестные пути уводим на главную */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
